"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatar = void 0;
var React = __importStar(require("react"));
var web_1 = require("../../InitialsAvatar/web");
var UserAvatar_style_1 = __importDefault(require("./UserAvatar.style"));
exports.UserAvatar = function (props) {
    var style = {};
    var sizeCircle = props.sizeCircle, size = props.size, _a = props.user, _b = _a.name, name = _b === void 0 ? '' : _b, image = _a.image, _c = props.skeleton, skeleton = _c === void 0 ? false : _c;
    var classStyle = 'ds-user-avatar';
    switch (size) {
        case 'xs':
        case 's':
        case 'm':
        case 'l':
        case 'xl':
            classStyle += " initials-" + size;
            break;
        default:
            classStyle += " initials-m";
    }
    if (sizeCircle) {
        style.width = sizeCircle + "px";
        style.height = sizeCircle + "px";
    }
    return image && !skeleton ? (React.createElement(UserAvatar_style_1.default, null,
        React.createElement("div", { className: classStyle, style: style },
            React.createElement("img", { src: image })))) : (React.createElement(web_1.InitialsAvatar, { skeleton: skeleton, name: name, size: size, sizeCircle: sizeCircle }));
};
//# sourceMappingURL=UserAvatar.js.map